<template>
<div id="AllergyModal" class="modal-area">
  <div class="modal-overlay" @click="hideModal()"></div>
  <div class="modal-body">
    <!-- <span class="close-btn" @click="hideModal()">&times;</span> -->

    <p class="feedback">{{feedback}}</p>

    <div class="profile-subnav">
      <button @click="changeTab(0)">
        <img src="@/assets/svg/pet-card-tabs/notepad.svg"/> Allergies </button>
        <div class="divider"></div>
        <button @click="changeTab(1)">
          <img src="@/assets/svg/pet-card-tabs/notepad.svg"/> Microchipped </button>
          <div class="divider"></div>
        <button  @click="changeTab(2)">
          <img src="@/assets/svg/pet-card-tabs/notepad.svg"/>Medical History</button>
    </div>

    <div class="allergy-form modal-body-text" v-if="tab_number == 0" >
      <div class="allergy-form modal-body-text">
        <div v-if="allergy_que.length > 0">
          <div class="allergy-cell cell-pods" v-for="(a, a_id) in allergy_que" :key="a_id">
            <span class="text-cell">
              {{a}}
              <input v-model="pet_data.allergies[a_id]" :placeholder="'Allergy ' + a_id  " v-if="editAllergy"/>
            </span>
            <span class="edit-icon">
              <img src="@/assets/icons/trash.svg" @click="deleteAllergyQue(a_id)"/>
            </span>
          </div>
        </div>
        <div v-if="editablePage">
          <div class="allergy-cell" v-if="!addingAllergy">
            <button class="add-btn" @click="addingAllergy = true">Add an Allergy</button>
          </div>
          <div class="allergy-cell add-new-allergy" v-else>
            <input v-model="new_allergyen" placeholder="Enter an allergy">
            <button class="add-btn" @click="addAllergyQue()" >Add</button>
          </div>
        </div>
      </div>
      <div v-if="!editablePage && allergy_que.length == 0 ">
        <p>This pet does not have any allergies</p>
      </div>

    </div>

    <div v-else-if="tab_number == 1">
      <p>This Pet Is Not Microchipped</p>
    </div>

    <div v-else-if="tab_number == 2">
      <p>This Pet Does Not Have A Medical History</p>
    </div>
  </div>
</div>
</template>
<script>
// import axios from 'axios'
import {db} from '@/_firebase/init';
// import {mapState, mapActions} from 'vuex'

export default {
  name: 'AllergyModal',
  props: ['pet_data', 'editablePage'],
  data(){
    return{
      pet_id: this.$route.params.pet_id,
      editAllergy: false,
      isEditing: false,
      tab_number: 0,
      total: 0,
      feedback:null,
      status:'danger',
      processing: false,
      allergy_que: [],
      addingAllergy: false,
      new_allergyen: '',
    errors: [],
    }
  },
  watch:{
    creatorID(nv,ov){
      console.log(nv, ov)
    }
  },
  methods: {
    changeTab(num){
      this.tab_number = num
    },
    hideModal(){
      this.$emit('hideModal', '')
    },
    async deleteAllergyQue(a_id){
      this.allergy_que.splice(a_id, 1);
      this.pet_data['allergies'] = this.allergy_que
      let data = {
        allergies: this.allergy_que
      }
      await db.collection('pets').doc(this.pet_id).update( data);
      console.log(this.allergy_que)
    },
    async addAllergyQue(){
      if(this.new_allergyen){
        this.allergy_que.push(this.new_allergyen);
        this.new_allergyen =''
        this.addingAllergy = false
        this.pet_data['allergies'] = this.allergy_que
        let data = {
          allergies: this.allergy_que
        }
        await db.collection('pets').doc(this.pet_id).update( data);
      }
      console.log(this.allergy_que)
    },
  },
  computed:{
  },
  created(){
    this.allergy_que = this.pet_data.allergies
  },
}
</script>
<style scoped>

#AllergyModal{
  position: fixed;
  top:0;
  left:0;
  z-index: 24;
  width: 100%;
  height: 105%;
  display:flex;
  align-items:center;
  justify-content:center;
  overflow: hidden;
  transition:1s;
}
.modal-overlay{
  position: absolute;
  top: 0;
  left: 0;
  background-color: #222;
  width: 100%;
  height: 110%;
  opacity: .7;
}
.close-btn{
  position: absolute;
  right: 1rem;
  top: .5rem;
  font-size: 2rem;
}
.modal-body{
  position: relative;
  padding: 0rem;
  width: 80%;
  margin: auto;
  border-radius: 12px;
  background-color: #ddd;
  z-index: 44;
  overflow: auto;
  transition:1s;
  min-height: 30vh;
}

.profile-subnav{
  width:100%;
  text-align: center;
  display: flex;
  justify-content: space-evenly;
  align-items:center;
  background: #32BA7C;
  color: #fff;
  font-size: 20px;
  padding:auto;
  text-align: center;
  border-radius:  10px 10px 0 0;
}
.profile-subnav  button {
  list-style-type: none;
  width: 100%;
  color: #fff;
  outline: none;
  background-color: transparent;
  /* border:.5px solid  #fff; */
  border:none;
  font-weight: bold;
  display: block;
  text-transform: uppercase;
  text-align: center;
  padding: 16px;
  overflow: hidden;
  display: flex;
  justify-content: space-evenly;
  align-items:center;
  cursor: pointer;
  height: 100%;
    font-size: .5rem;
}
.profile-subnav  button img{
  width: 2.2rem;
  height: 2rem;
}
.profile-subnav  button:hover{
  background-color: #99dbbd;
  color: #35976a;
}
.divider{
  width: .3rem;
  height: 40px;
  background: #99dbbd;
}
.modal-body-text{
  margin: 1rem 3rem;
  transition: 1s;
}
.allergy-cell{
  width: 100%;
  display:flex;
  justify-content: space-between;
  align-items:center;
  font-size: .9rem;
  margin: 1rem auto;
  /* transition: 1s;s */
}
.cell-pods{
    background-color: #fff;
    border-radius: 10px;
    color: #333;
    margin: .5rem auto;
    /* border-bottom: 2px solid #444; */
    display: flex;
    align-items:center;
    justify-content: space-between;
    padding: .8rem 0;
}
.text-cell{
  width: 80%;
  margin: auto;
}
.allergy-cell input{
  font-size: 1rem;
  border: none;
  border-bottom: 1px solid #efefef;
}

.pet-text-data{
  width: 60%;
  font-size: .9rem;
}
.add-new-allergy input{
  justify-content: space-evenly;
  align-items:center;
  padding: .2rem 1rem !important;
  height: 2rem;
  border-radius: 10px;
  width: 70%;
  border: 2px solid #dfdfdf;
  transition: 1s;
}
.feedback{color: #ff1231;}
.add-new-allergy .add-btn{
  width: 30%;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  text-align: center;
  margin: 1rem auto;
  margin-left: 1rem;
  /* transition: 1s; */
  color: #fff;
  background-color: #32BA7C;
}
.edit-icon{
  border-radius: 100%;
}
.edit-icon img{
  width: 1.5rem;
  height: 1.5rem;
  margin: auto .6rem;
  cursor: pointer;
  transition: 1s;
}
.edit-icon img:hover{
  background-color: #ccc;
}
.btn-group{
  width: 100%;
  display: flex;
  jusitfy-content: space-between;
}
.modal-btn{
  width: 45%;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  text-align: center;
  padding: .7rem;
  margin: 1rem auto;
  transition: 1s;
  color: #fff;
  background-color: var(--link-light);
}
.gender-btn{
  padding: .5rem;
  margin: .1rem;
  transition: 1s;
  border-radius: 2px;
  background-color: var(--primary);
  border:none;
  color: #fff;
}
.fe{
  background-color: #ee9aba;
}
.add-btn{
  width:100%;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  text-align: center;
  padding: .7rem;
  margin: 1rem auto;
  /* transition: 1s; */

  outline: none;
  color: #fff;
  cursor:pointer;
  background-color: #32BA7C;
}
.no-btn{
  margin:0;
  background-color: var(--bg-secondary);
}
.btn-group{
  display:flex;
  width:100%;
  justify-content:center;
  margin: 0 auto;
  transition: 1s;
}
.cancel-btn{
  background-color: var(--bg-dark);
}
body[data-theme='dark'] .modal-body{
  background-color: var(--bg-dark);
  color: var(--text-dark);
}
@media screen and (max-width: 600px) {
  .modal-body-text{
    margin: 1rem;
  }
  .profile-subnav  button {
      font-size: .4rem;
  }
  .profile-subnav  button img{
    width: .92rem;
    height: .92rem;
  }
  .allergy-cell{
    font-size: .8rem;
    margin: .5rem auto;
  }
  .edit-icon img{
    width: 1rem;
    height: 1rem;
    margin: auto .6rem;
  }
  .modal-body{
    width: 85%;
  }
  .add-btn{
    width:100%;
    border: none;
    border-radius: 10px;
    font-size: 1rem;
    text-align: center;
    padding: .7rem;
    margin: 1rem auto;
  }
  .btn-group{
    width:100%;
  }
  .default-info-btn{
    padding:.5rem .8rem;
    font-size :.6rem;
  }
}
</style>
